import React from "react";
import AspectRatio from "@/components/layout/AspectRatio";
import BackgroundImage from "@/components/media/BackgroundImage/background-image";
import { breakpointClasses, cn, splitBreakpointProps } from "@/lib/utils";
import type { LinkButtonProps } from "../Link";
import LinkButton from "../Link";
import type { ImageButtonProps } from "./types";

function ButtonImage({
  src,
  alt,
  presetRatio = "square",
  aspectRatioProps = {},
  backgroundImageProps = {},
  className = "",
  children,
  ...props
}: ImageButtonProps) {
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  return (
    <AspectRatio
      presetRatio={presetRatio}
      className={cn(aspectRatioProps.className)}
      {...aspectRatioProps}
    >
      <LinkButton
        className={cn("w-full h-full", className, classes)}
        variant="ghost"
        {...(native as LinkButtonProps)}
      >
        <BackgroundImage
          src={src}
          alt={alt}
          fill={true}
          sizes="50vw"
          presetRatio={presetRatio}
          {...backgroundImageProps}
        >
          {children}
        </BackgroundImage>
      </LinkButton>
    </AspectRatio>
  );
}

export default ButtonImage;
